import { StandardEvents } from '@shopify/events';

// Presentation only: the native picker remains responsible for media, price and cart.
const configNode = document.getElementById('ova-immersive-config');
if (configNode && !window.ovaImmersiveProductLoaded) {
  window.ovaImmersiveProductLoaded = true;
  const config = JSON.parse(configNode.textContent);
  const root = document.documentElement;
  let revision = 0;
  const apply = (id) => {
    const variant = config.variants.find((entry) => entry.id === String(id));
    if (!variant) return;
    const style = document.createElement('span').style;
    style.cssText = variant.tokens;
    for (let index = 0; index < style.length; index++) {
      const key = style.item(index);
      root.style.setProperty(key, style.getPropertyValue(key));
    }
  };
  apply(config.initialVariant);
  document.addEventListener(StandardEvents.productSelect, (event) => {
    const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
    if (!picker || !picker.closest('#MainContent .product-information') || picker.closest('product-card, quick-add-dialog')) return;
    if (String(picker.dataset.productId) !== config.productId) return;
    const currentRevision = ++revision;
    const options = picker.getAllSelectedOptions?.().map((option) => option.value) || [];
    const selected = config.variants.find((entry) => entry.options.length === options.length && entry.options.every((value, index) => value === options[index]));
    if (selected) apply(selected.id);
    event.promise?.then(({ detail }) => {
      if (currentRevision !== revision) return;
      if (detail?.resource?.id) apply(detail.resource.id);
    }).catch(() => {
      // The native picker reports network errors; retain the user's chosen palette.
    });
  });
}
